import { linkKindForService } from '@/data/services';
import type { LinkService } from '@/data/services';
import type { PublicProfileData, ApiLink } from '@/types/dashboard';
import nestraAvatar from '@/assets/avatars/nestra.svg';

// Static demo profile shown at /nestra (a reserved handle, never a real user).
// Rendered through the same ProfileView as real profiles, so it's indistinguishable
// from a live page — but needs no API call. Releases + events are intentionally
// empty (those sections self-hide), showcasing socials, streaming, and contact.

const link = (id: string, service: LinkService, url: string): ApiLink => ({
  id,
  service,
  kind: linkKindForService(service),
  url,
});

export const EXAMPLE_PROFILE: PublicProfileData = {
  profile: {
    name: 'Nestra',
    handle: 'nestra',
    avatar: nestraAvatar,
    avatarPreset: 'cosmic',
    useAvatarPreset: false,
    profession: 'Creative Platform',
    bio: "Your creative identity, in one link. Nestra is your digital ID card. It's a single place for your entire online presence, where your audience can discover everything about you from one link.",
    badgeText: 'Create your Nestra profile',
    openToCollabs: true,
    theme: 'paper',
  },
  releases: [],
  events: [],
  links: [
    link('ex-website', 'website', 'https://nestra.me'),
    link('ex-x', 'x', 'https://x.com/nestra_me'),
    link('ex-tiktok', 'tiktok', 'https://tiktok.com'),
    link('ex-github', 'github', 'https://github.com'),
    link('ex-dribbble', 'dribbble', 'https://dribbble.com'),
    link('ex-behance', 'behance', 'https://www.behance.net'),
    link('ex-goodreads', 'goodreads', 'https://goodreads.com'),
  ],
  contacts: [
    {
      id: 'ex-c1',
      channel: 'email',
      label: 'General',
      value: 'hello@nestra.me',
    },
    {
      id: 'ex-c2',
      channel: 'email',
      label: 'Collaborations',
      value: 'partners@nestra.me',
    },
  ],
};
